// Copyright 2026 Hardfin, Inc.
import { LocationForLabel, LocationLabel } from '@/components/location-label';
import { Stack } from '@mui/material';

interface LocationPairCellProps {
  fromLocation: LocationForLabel | null;
  toLocation: LocationForLabel | null;
  showThirdPartyChip?: boolean;
}

export function LocationPairCell(props: LocationPairCellProps) {
  return (
    <Stack spacing={0.5} sx={{ width: '100%' }}>
      <LocationLabel
        label="From:"
        location={props.fromLocation}
        showThirdPartyChip={props.showThirdPartyChip}
      />
      <LocationLabel
        label="To:"
        location={props.toLocation}
        showThirdPartyChip={props.showThirdPartyChip}
      />
    </Stack>
  );
}
